module.exports = __webpack_public_path__ + "static/media/pages_active.df4bff8d.svg";